import React from "react";
import { findObjectUseCase } from "../../usecases/object";

const defaultProps = {
  where: {},
  onSelect: () => {},
};
function DialogTable({ schema, where, onCancel, title, onSelect }) {
  const [objects, setObjects] = React.useState([]);
  const [progress, setProgress] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const [skip, setSkip] = React.useState(0);
  const [hasMore, setHasMore] = React.useState(true);
  const [selectedItems, setSelectedItems] = React.useState({});

  const limit = 10;

  const debouncedSearch = useDebounce(search, 300);

  async function fetchData(isInitial = false) {
    try {
      setProgress(true);
      const find = findObjectUseCase();
      const query = {
        where: {
          ...where,
          ...(debouncedSearch
            ? {
                $or: [
                  { sku: { $regex: debouncedSearch, $options: "i" } },
                  { itemName: { $regex: debouncedSearch, $options: "i" } },
                ],
              }
            : {}),
        },
        include: ["uom"],
        limit,
        skip: isInitial ? 0 : skip,
      };

      const newObjects = await find.execute(schema.collection, query);

      if (isInitial) {
        setObjects(newObjects);
      } else {
        setObjects((prev) => [...prev, ...newObjects]);
      }

      setSkip((prev) => prev + limit);
      if (newObjects.length < limit) {
        setHasMore(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setProgress(false);
    }
  }

  function useDebounce(value, delay = 300) {
    const [debounced, setDebounced] = React.useState(value);

    React.useEffect(() => {
      const handler = setTimeout(() => setDebounced(value), delay);
      return () => clearTimeout(handler);
    }, [value, delay]);

    return debounced;
  }

  React.useEffect(() => {
    setSkip(0);
    setHasMore(true);
    fetchData(true); // initial load
  }, [schema, where, debouncedSearch]);

  function handleScroll(e) {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 20 && !progress && hasMore) {
      fetchData(false);
    }
  }

  return (
    <div
      className="d-flex flex-column"
      style={{
        height: "500px", // force a consistent modal height
        maxHeight: "80vh",
        minHeight: "400px",
      }}
    >
      <div className="p-3 pb-1">
        <h5 className="fw-bold mb-2">Choose Item</h5>
      </div>

      <div
        className="px-3"
        style={{
          flex: 1,
          overflowY: "auto",
        }}
        onScroll={handleScroll}
      >
        <div className="input-group mb-3">
          <span className="input-group-text bg-white">
            <i className="bi bi-search text-success"></i>
          </span>

          <input
            type="text"
            className="form-control border-success"
            placeholder="Search"
            style={{ borderLeft: "0" }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <table className="table table-bordered text-center align-middle">
          <thead style={{ backgroundColor: "#82c14a", color: "white" }}>
            <tr>
              <th
                style={{
                  backgroundColor: "#82c14a",
                  color: "white",
                }}
              >
                SKU
              </th>
              <th
                style={{
                  backgroundColor: "#82c14a",
                  color: "white",
                }}
              >
                Item Name
              </th>
              <th
                style={{
                  backgroundColor: "#82c14a",
                  color: "white",
                }}
              >
                UOM
              </th>
              <th
                style={{
                  backgroundColor: "#82c14a",
                  color: "white",
                }}
              >
                COST
              </th>
              <th
                style={{
                  backgroundColor: "#82c14a",
                  color: "white",
                }}
              >
                Qty
              </th>
            </tr>
          </thead>
          <tbody>
            {objects.length === 0 && !progress ? (
              <tr>
                <td colSpan="3" className="text-center py-4 text-muted">
                  <span>“{debouncedSearch}” not found.</span>
                  <i className="bi bi-emoji-frown"></i>
                </td>
              </tr>
            ) : (
              objects.map((item, index) => (
                <tr key={item.id || index}>
                  <td>{item.sku}</td>
                  <td>{item.itemName}</td>
                  <td>{item?.uom?.name}</td>
                  <td>{item?.cost}</td>
                  <td>
                    <input
                      type="number"
                      min="1"
                      value={selectedItems[item.id]?.quantity || ""}
                      onChange={(e) => {
                        const qty = e.target.value;
                        setSelectedItems((prev) => ({
                          ...prev,
                          [item.id]: {
                            ...item,
                            quantity: qty.toString(), // store as string
                            stock_quantity: item?.stock_quantity,
                            component_quantity: item?.quantity,
                          },
                        }));
                      }}
                      className="form-control form-control-sm text-center border-success"
                      style={{ width: "120px", margin: "0 auto" }}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        {progress && hasMore && (
          <div className="text-center my-3">
            <div
              className="spinner-border text-success"
              role="status"
              style={{ width: "2rem", height: "2rem" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        )}
      </div>

      <div
        className="d-flex justify-content-center gap-3 p-3 border-top"
        style={{ backgroundColor: "#fff" }}
      >
        <button
          type="button"
          className="btn btn-light btn-sm px-4"
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn btn-success text-white btn-sm px-4"
          onClick={() => {
            const selected = Object.values(selectedItems)
              .filter((i) => i.quantity)
              .map((item) => {
                console.log("how", item);
                const clean = { ...item };
                // delete clean.quantity; // REMOVE OLD FIELD
                return clean;
              });

            onSelect(selected); // send to parent
            onCancel();
          }}
        >
          Save
        </button>
      </div>
    </div>
  );
}

DialogTable.defaultProps = defaultProps;
export default DialogTable;
